import { useCallback, useEffect, useState } from "react";
import { listAgents } from "./workerLineApi.js";

export const AGENTS_DEFAULT_PAGE_SIZE = 25;

/**
 * Fetches GET /api/backoffice/worker-line/agents with real server-side
 * pagination/filtering - mirrors ./useSuperAgentsList.js. Refetches every
 * time `filters` changes (superAgentOrganizationId, plcOrganizationId,
 * search, status, page, pageSize). `filters` must be a stable object
 * reference (useMemo).
 */
export function useAgentsList(filters) {
  const [state, setState] = useState({ status: "loading", data: null, error: null });
  const [reloadToken, setReloadToken] = useState(0);

  useEffect(() => {
    let cancelled = false;
    setState((previous) => ({ status: "loading", data: previous.data, error: null }));

    listAgents(filters)
      .then((data) => {
        if (!cancelled) {
          setState({ status: "ready", data, error: null });
        }
      })
      .catch((error) => {
        if (!cancelled) {
          setState((previous) => ({ status: "error", data: previous.data, error }));
        }
      });

    return () => {
      cancelled = true;
    };
  }, [filters, reloadToken]);

  const refetch = useCallback(() => setReloadToken((token) => token + 1), []);

  return { ...state, refetch };
}
